import { createContext, useContext, useState, useEffect } from "react";
import { api, fmtXof } from "../lib/api";

const CurrencyContext = createContext(null);
const KEY = "vitalis_currency";

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => localStorage.getItem(KEY) || "XOF");
  const [data, setData] = useState(null); // {rates, labels, stripe_currencies}

  useEffect(() => {
    api.get("/currencies").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, code);
  }, [code]);

  const rates = data?.rates || {};
  const labels = data?.labels || { XOF: "Franc CFA (FCFA)" };
  const stripeCurrencies = data?.stripe_currencies || ["EUR"];

  const convert = (xof) => (code === "XOF" || !rates[code]) ? xof : xof / rates[code];

  const fmtIn = (cur, xof) => {
    const rate = rates[cur];
    if (cur === "XOF" || !rate) return fmtXof(Math.round(xof / 50) * 50);
    const digits = cur === "CNY" ? 1 : cur === "RUB" ? 0 : 2;
    try {
      return new Intl.NumberFormat("fr-FR", { style: "currency", currency: cur, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(xof / rate);
    } catch {
      return fmtXof(xof);
    }
  };

  const fmt = (xof) => fmtIn(code, xof);

  // Devise réellement débitée par carte : CNY/RUB traités en USD équivalent, XOF converti en EUR
  const chargeCurrency = stripeCurrencies.includes(code) ? code : (code === "CNY" || code === "RUB") ? "USD" : "EUR";
  const fmtCharge = (xof) => fmtIn(chargeCurrency, xof);
  const updatedAt = data?.updated_at || null;
  const rateText = code !== "XOF" && rates[code] ? `1 ${code} = ${Math.round(rates[code]).toLocaleString("fr-FR")} FCFA` : "";

  return (
    <CurrencyContext.Provider value={{ code, setCode, rates, labels, fmt, convert, chargeCurrency, fmtCharge, updatedAt, rateText, loaded: !!data }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
